import CourseUsersList from './CourseUsersList.gql';

export default CourseUsersList;
